import { motion } from "framer-motion";

const stats = [
  { n: "+20", label: "Years combined field experience" },
  { n: "+500", label: "Projects delivered by partners" },
  { n: "3", label: "Global operating centres" },
  { n: "24/7", label: "Operational readiness" },
];

export default function Stats() {
  return (
    <section
      className="relative py-24 md:py-32 border-t border-navy-border"
      data-testid="stats"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-y-14 gap-x-8">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col"
            data-testid={`stat-${i}`}
          >
            <span className="font-display text-6xl md:text-7xl text-gold leading-none">
              {s.n}
            </span>
            <span className="mt-6 font-mono text-[11px] tracking-[0.25em] uppercase text-white/60 max-w-[220px] leading-[1.6]">
              {s.label}
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
